module.exports = __webpack_public_path__ + "img/563.18970e8f.jpg";